import { useEffect, type ReactNode } from "react";
import { CkConfirmHost, CkThemeProvider, CkToastProvider } from "@NP-Webber/crm-kit/dist/next/index.js";
import { useAuth } from "../../auth/AuthProvider";
import { setDesignUser, useDesign } from "./useDesign";

/**
 * DesignRoot — the theme root of the whole app (login, organization picker, public forms and the shell):
 * the user's style × mode as crm-kit/next tokens, toasts and the promise-based confirm dialog.
 * Legacy crm-kit pieces (TableKit, FormDialog, ExtendedCard…) render their new-design versions under it.
 */
export function DesignRoot({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const userId = auth.user?.id ?? null;
  // before the first render under a new user, so the right look paints immediately
  setDesignUser(userId);
  const design = useDesign();

  useEffect(() => {
    document.documentElement.dataset.tbMode = design.mode;
  }, [design.mode]);

  return (
    <CkThemeProvider style={design.style} mode={design.mode} className="tb-next">
      <CkToastProvider>
        {children}
        <CkConfirmHost />
      </CkToastProvider>
    </CkThemeProvider>
  );
}

export default DesignRoot;
